import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { EmojiSize } from '../emoji/emoji.component';
import { emojiLongnameList } from '../emoji/map';
import { HoverColor, IconColor, IconSize } from '../icon/icon.component';

@Component({
  selector: 'fl-emoji-picker',
  template: `
    <fl-button
      flTrackingLabel="emojiPicker"
      (click)="handleEmojiButtonClick()"
      data-uitest-target="emojipicker-button"
      [disabled]="disabled"
    >
      <fl-icon
        [color]="disabled ? IconColor.MID : IconColor.DARK"
        [size]="IconSize.SMALL"
        [hoverColor]="HoverColor.PRIMARY"
        name="ui-smile"
        label="Pick an emoji"
      ></fl-icon>
    </fl-button>

    <fl-bit
      *ngIf="emojiPickerIsOpen"
      class="EmojiPicker-card"
      data-uitest-target="emojipicker"
    >
      <fl-emoji
        *ngFor="let emojiName of emojiLongnameList"
        class="EmojiPicker-item"
        [emoji]="emojiName"
        [size]="EmojiSize.SMALL"
        (click)="handleEmojiPick(emojiName)"
      ></fl-emoji>
    </fl-bit>
  `,
  styleUrls: ['./emoji-picker.component.scss'],
})
export class EmojiPickerComponent {
  EmojiSize = EmojiSize;
  IconColor = IconColor;
  IconSize = IconSize;
  HoverColor = HoverColor;

  @Input() disabled = false;

  @Output() emojiPicked = new EventEmitter<string>();

  emojiLongnameList = emojiLongnameList;
  emojiPickerIsOpen = false;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  handleClickOutsideEmojiPicker(event: MouseEvent) {
    if (
      this.emojiPickerIsOpen &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.emojiPickerIsOpen = false;
    }
  }

  handleEmojiPick(emojiName: string) {
    this.emojiPickerIsOpen = false;
    this.emojiPicked.emit(emojiName);
  }

  handleEmojiButtonClick() {
    this.emojiPickerIsOpen = !this.emojiPickerIsOpen;
  }
}
